import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import map from 'lodash/map'

import ProjectSearchItem from './ProjectSearchItem'
import Pagination from '@components/Pagination'
import Spinner from '@components/spinner'

class ProjectSearchResults extends Component {
  static propTypes = {
    projectSearchStore: PropTypes.object,
    history: PropTypes.object
  }

  onSelect = id => this.props.projectSearchStore.selectExpert(id)

  onLink = (e, id) => {
    if (e.target.className === 'name') return true // If user clicks on name just opoen link
    e.preventDefault()
    this.props.projectSearchStore.select(id)
    this.props.history.push(
      '/project-search/project/' + id + this.props.projectSearchStore.openIn
    )
  }

  renderSortOrder () {
    if (this.props.projectSearchStore.bestMatchSort) {
      return (
        <>
          <strong
            style={{ display: 'inline' }}
            onClick={() =>
              (this.props.projectSearchStore.query.sortBy = 'match')
            }
            className={
              this.props.projectSearchStore.query.sortBy !== 'date'
                ? 'strong'
                : 'link'
            }
          >
            best match
          </strong>
          /
          <strong
            onClick={() =>
              (this.props.projectSearchStore.query.sortBy = 'date')
            }
            style={{ display: 'inline' }}
            className={
              this.props.projectSearchStore.query.sortBy === 'date'
                ? 'strong'
                : 'link'
            }
          >
            start date
          </strong>
        </>
      )
    } else {
      return <strong>start date</strong>
    }
  }

  render () {
    const { projectSearchStore } = this.props

    if (projectSearchStore.loading) return <Spinner />

    return (
      <div>
        <div className='expert-search-header'>
          <h4 className='expert-search-total'>
            {this.props.projectSearchStore.total?.value ?? 0} projects
            <span className='project-search-results__expert-search-total__ordered-by'>
              {' '}
              ordered by {this.renderSortOrder()}
            </span>
          </h4>
        </div>

        <div className='project-search-results__search-items-wrapper'>
          {map(this.props.projectSearchStore.projects, project => {
            return (
              <div
                key={project.id}
                className='expert-search-item-container project-search-results__search-item-container'
              >
                <Link
                  onClick={e => this.onLink(e, project.id)}
                  to={
                    '/project/' +
                    project.id +
                    this.props.projectSearchStore.openIn
                  }
                >
                  <ProjectSearchItem
                    project={project}
                    isSelected={
                      this.props.projectSearchStore.selected === project.id
                    }
                  />
                </Link>
              </div>
            )
          })}
        </div>
        <Pagination
          maxPages={100}
          total={this.props.projectSearchStore.total?.value??0}
          perPage={10}
          page={this.props.projectSearchStore.query.page}
          onChange={p => this.props.projectSearchStore.changePage(p)}
        />
      </div>
    )
  }
}

export default withRouter(
  inject('projectSearchStore')(observer(ProjectSearchResults))
)
